import React, { FC } from 'react'

import { Page, PageContent } from 'common'
import { HeaderSkeleton } from 'components/header'

import { Skeleton } from '@interco/inter-ui/components/Skeleton'

import { HomeContainer, MenuContainer } from '../styles/styles'

export const HomeSkeleton: FC = () => (
  <Page>
    <HeaderSkeleton />
    <PageContent>
      <HomeContainer>
        <MenuContainer>
          <Skeleton height="3.765rem" width="100%" style={{ marginBottom: '8px' }} />
          <Skeleton height="3.765rem" width="100%" style={{ marginBottom: '8px' }} />
          <Skeleton height="3.765rem" width="100%" style={{ marginBottom: '8px' }} />
        </MenuContainer>
        <Skeleton height="6.625rem" width="100%" />
        <Skeleton height="5.25rem" width="100%" />
      </HomeContainer>
    </PageContent>
  </Page>
)
